<template>
  <v-textarea
    v-if="abstractRows > 0"
    :rows="abstractRows"
    filled
    name="memoDescription"
    :label="label"
    :value="memoDescription"
    dense
    :readonly="!disabled"
    :max="maxLength"
    :maxlength="maxLength"
    :counter="maxLength"
    @blur="onBlur"
    @input="onInput"
    no-resize
  ></v-textarea>
</template>

<script>
import { TITLE_LENGTH_1000 } from "@/utils/constant";
export default {
  name: "TopicMemo",
  props: {
    value: {
      type: String,
      default: "",
    },
    disabled: Boolean,
    abstractRows: Number,
  },
  data: function () {
    return {
      maxLength: TITLE_LENGTH_1000,
      originalMemoDescription: "",
      currentMemoDescription: "",
    }
  },
  computed: {
    memoDescription() {
      return this.value;
    },
    label() {
      return this.$t("agenda.lblTopicMemo");
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.originalMemoDescription = newValue || "";
        this.currentMemoDescription = newValue || "";
      }
    }
  },
  methods: {
    onInput(value) {
      this.currentMemoDescription = value || "";
    },
    onBlur(event) {
      const value = event.currentTarget.value;
      const trimmedValue = String(value).trim() || "";
      
      if (trimmedValue !== this.originalMemoDescription) {
        this.$emit("input", trimmedValue);
        this.$eventHub?.$emit?.("onMeetingUpdate");
        
        this.originalMemoDescription = trimmedValue;
      }
      
      this.currentMemoDescription = trimmedValue;
    },
  },
};
</script>